import { render, staticRenderFns } from "./WGrabar.vue?vue&type=template&id=063110f3&scoped=true&"
import script from "./WGrabar.vue?vue&type=script&lang=js&"
export * from "./WGrabar.vue?vue&type=script&lang=js&"
import style0 from "./WGrabar.vue?vue&type=style&index=0&id=063110f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063110f3",
  null
  
)

export default component.exports